import { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { BsCheck2 } from 'react-icons/bs'
import { IoCopy } from 'react-icons/io5'
import QRCode from 'react-qr-code'

import { ExchangeSymbol } from '../../components/Dashboard/svgs/ExchangeSymbol'
import { RateSymbol } from '../../components/Dashboard/svgs/RateSymbol'
import { WalletSymbol } from '../../components/Dashboard/svgs/WalletSymbol'
import { SellUSDTViaWallet } from '../../components/Dashboard/tron-wallet/SellUSDTViaWallet'
import { SendTron } from '../../components/Dashboard/tron-wallet/SendTron'
import { SendUsdt } from '../../components/Dashboard/tron-wallet/SendUsdt'
import { RecentTronTransactions } from '../../components/RecentTronTransactions'
import { RecentUsdtTransactions } from '../../components/RecentUsdtTransactions'
import { useGetUsdtRateQuery } from '../../features/trade&coins/bitcoinSlice'
import { useGetResourcesQuery, useGetTronBalanceQuery, useGetTronWalletQuery } from '../../features/tron-wallet/tronWalletSlice'
import { Loader } from '../../shared/Loader'
import toast from 'react-hot-toast'

export const UsdtWallet = () => {
  const [is2FAAuthenticated, setIs2FAAuthenticated] = useState(false)

  const { data: tronWallet, isLoading: isTronWalletLoading } =
    useGetTronWalletQuery()

  const { data: balance, isLoading: isBalanceLoading } = useGetTronBalanceQuery();
  const { data: resource, isLoading: isResourceLoading } = useGetResourcesQuery();

  // copy to clipboard state -----------
  const [copy, setCopy] = useState<{ value: string; copied: boolean }>({
    value: tronWallet?.address || '',
    copied: false,
  })

  const { data: usdtRate, isLoading: isUsdtRateLoading } =
    useGetUsdtRateQuery()

  return (
    <div className='font-dashboard pt-8 pb-32 lg:px-4'>
      <div className='container-lg grid grid-cols-1 lg:grid-cols-4 gap-4'>
        <div className='lg:col-span-3'>
          <div className='bg-black flex justify-between px-4 lg:px-10 py-10 md:flex-row flex-col gap-4'>
            <div className='flex flex-col justify-between bg-[url("/images/dashboard/OBJECTS.png")] bg-no-repeat bg-bottom'>
              <div>
                <p className='text-base md:text-lg lg:text-xl text-white/40 font-light'>
                  USDT Wallet
                </p>
                <h1 className='text-white flex items-center gap-4'>
                  <span>USDT</span>{' '}
                  {isBalanceLoading ? (
                    <div className='h-8 w-40 bg-white/50 animate-pulse' />
                  ) : (
                    balance?.["formatted_balance"]?.usdt
                  )}
                </h1>
                <h3 className='text-white flex items-center gap-4'>
                  {isBalanceLoading ? (
                    <div className='h-8 w-40 bg-white/50 animate-pulse' />
                  ) : (
                    `$ ${(balance?.["formatted_balance"]?.usdt * usdtRate?.usd).toFixed(2)}`
                  )}
                </h3>
              </div>

              <div className='flex items-center gap-2 divide-x-2 divide-gray-500 mt-2'>
                <div className='flex flex-col justify-center gap-2'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-indigo-500 text-indigo-500 md:rounded-full box-content md:p-1'>
                      <RateSymbol size={12} />
                    </div>
                    <p className='text-white/40 font-light text-sm md:text-base'>
                      Rate
                    </p>
                  </div>

                  <p className='text-white flex items-center text-lg md:text-xl gap-2'>
                    {isUsdtRateLoading ? (
                      <div className='h-3 w-32 bg-white/50 animate-pulse' />
                    ) : (

                      <div className='text-sm'>
                        <div>
                          {usdtRate?.ngn?.toFixed(2)} NGN/USDT
                        </div>
                      </div>
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div className='flex flex-col justify-between bg-[url("/images/dashboard/OBJECTS.png")] bg-no-repeat bg-bottom'>
              <div>
                <p className='text-base md:text-lg lg:text-xl text-white/40 font-light'>
                  Tron Wallet
                </p>
                <h1 className='text-white flex items-center gap-4'>
                  <span>TRX</span>{' '}
                  {isBalanceLoading ? (
                    <div className='h-8 w-40 bg-white/50 animate-pulse' />
                  ) : (
                    balance?.["formatted_balance"]?.trx
                  )}
                </h1>
              </div>

              <div className='flex items-center gap-2 divide-x-2 divide-gray-500 mt-2 justify-between'>
                <div className='flex flex-col justify-center gap-2'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-indigo-500 text-indigo-500 md:rounded-full box-content md:p-1'>
                      <ExchangeSymbol size={12} />
                    </div>
                    <p className='text-white/40 font-light text-sm md:text-base'>
                      Bandwidth
                    </p>
                  </div>

                  <p className='text-white flex items-center text-lg md:text-xl gap-2'>
                    {isResourceLoading ? (
                      <div className='h-3 w-32 bg-white/50 animate-pulse' />
                    ) : (

                      <div className='text-sm'>
                        <div>
                          {resource?.bandWidth} of 600
                        </div>
                      </div>

                    )}
                  </p>
                </div>
                <div className='flex flex-col justify-center gap-2'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-indigo-500 text-indigo-500 md:rounded-full box-content md:p-1'>
                      <WalletSymbol size={12} />
                    </div>
                    <p className='text-white/40 font-light text-sm md:text-base'>
                      Energy
                    </p>
                  </div>

                  <p className='text-white flex items-center text-lg md:text-xl gap-2'>
                    {isResourceLoading ? (
                      <div className='h-3 w-32 bg-white/50 animate-pulse' />
                    ) : (

                      <div className='text-sm'>
                        <div>
                          {resource?.energy} of 0
                        </div>
                      </div>

                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Transactions Table */}

          <RecentUsdtTransactions />
          <RecentTronTransactions />
        </div>

        <div className='bg-black h-screen px-2 py-8 flex flex-col gap-4 z-0'>
          <div className='flex flex-col px-12 py-6 gap-12'>
            <div className='flex items-center justify-between gap-10 max-w-md mx-auto'>
              {/* Send button with modal  --------------------------------*/}
              <SendTron
                is2FAAuthenticated={is2FAAuthenticated}
                setIs2FAAuthenticated={setIs2FAAuthenticated}
              />
              <SendUsdt
                is2FAAuthenticated={is2FAAuthenticated}
                setIs2FAAuthenticated={setIs2FAAuthenticated}
              />
              {/*--------------------------------*/}

              {/* Sell via wallet button with modal  --------------------------------*/}
              <SellUSDTViaWallet
                is2FAAuthenticated={is2FAAuthenticated}
                setIs2FAAuthenticated={setIs2FAAuthenticated}
              />
              {/*--------------------------------*/}
            </div>
            <div className='max-w-max text-white/90 text-xs mx-auto pb-2 border-b border-indigo-500'>
              Transaction History
            </div>
          </div>

          <hr className='border-gray-600' />

          <p className='text-lg tracking-wide font-[200] text-white/40 text-center'>
            Scan QR code with your <br /> mobile wallet app
          </p>

          <div className='w-64 h-64 border-[10px] border-white box-content bg-gray-300/50 rounded-md mx-auto mt-4'>
            {isTronWalletLoading ? (
              <div className='w-full h-full flex justify-center items-center'>
                <Loader />
              </div>
            ) : (
              <QRCode
                width='100%'
                height='auto'
                value={`${tronWallet?.address}`}
              />
            )}
          </div>

          <CopyToClipboard
            text={tronWallet?.address}
            onCopy={() => {
              toast.success('Copied to clipboard')
              setCopy({ ...copy, copied: true })
            }
            }
          >
            <div className='transition-all duration-200 flex justify-between items-center bg-gray-700 hover:bg-gray-700/50 px-4 py-2 rounded-lg mt-8 cursor-pointer'>
              <div className='flex flex-col gap-1'>
                <p className='text-xs text-white/40'>
                  Tap to copy USDT (TRC20) address
                </p>
                <p className='text-sm text-white/80'>
                  {isTronWalletLoading ? (
                    <div className='h-2 w-32 bg-white/50 animate-pulse' />
                  ) : (
                    tronWallet?.address
                  )}
                </p>
              </div>
              {copy.copied ? (
                <BsCheck2 className='text-2xl text-green-500' />
              ) : (
                <IoCopy className='text-2xl text-white/80' />
              )}
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  )
}
